import { FunnelStatusTerminalOutcome } from 'src/api/generated';
import type {
  ConversationCardFooterProps,
  ConversationFooterTag,
} from '../types/conversation-card.type';

/**
 * Derives one ordered source for both inline footer badges and overflow labels.
 * @param props - Conversation flags and the optional funnel status.
 * @param testLabel - Translated test-conversation label.
 * @returns The applicable labels with their existing semantic colors.
 */
export const getConversationFooterTags = (
  {
    isTestConversation,
    status,
    isArchived,
    replyNeeded,
  }: Omit<ConversationCardFooterProps, 'assignedUserName'>,
  testLabel: string
): ConversationFooterTag[] => {
  const tags: ConversationFooterTag[] = [];
  if (isTestConversation) {
    tags.push({ key: 'test', label: testLabel, variant: 'warning' });
  }
  if (status) {
    tags.push({
      key: 'status',
      label: status.name,
      status,
      variant: status.terminalOutcome
        ? status.terminalOutcome === FunnelStatusTerminalOutcome.POSITIVE
          ? 'success'
          : 'secondary'
        : undefined,
    });
  }
  if (isArchived || replyNeeded) {
    tags.push({
      key: 'attention',
      label: isArchived ? 'Archivada' : 'Atender',
      variant: isArchived ? 'neutral' : 'warning',
    });
  }
  return tags;
};
